import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** pause bars. Decorative line icon; always pair with a visible text label. */
export function PauseIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M9 5.5v13" />
      <path d="M15 5.5v13" />
    </IconSvg>
  )
}
